import type { JSX, ReactNode } from "react";

export interface ProgressIndicatorProps {
  /**
   * If provided, the children will be rendered directly below the progress
   * indicator within a vertical flex element.
   */
  children?: ReactNode;

  /** The color of the spinning circular bands of the indicator */
  color?: string | undefined;
}

export function ProgressIndicator(props: ProgressIndicatorProps): JSX.Element {
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "var(--size-medium)",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="50"
        height="50"
        color={props?.color}
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          stroke="currentColor"
          strokeWidth="5"
          fill="none"
          strokeDasharray="31.4 31.4"
          strokeDashoffset="0"
          strokeLinecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
      {props?.children}
    </div>
  );
}
